(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  document.querySelectorAll('[data-loc-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-header-loc]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      if (form) form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-trio-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-home-trio]');
    if (!root) return;

    var countdown = root.querySelector('[data-home-trio-countdown]');
    var time = root.querySelector('[data-home-trio-countdown-time]');
    var end = root.getAttribute('data-countdown-end');
    if (!countdown || !time || !end) return;

    var deadline = new Date(end).getTime();
    if (!isFinite(deadline)) return;

    var timer;
    function renderCountdown() {
      var remaining = deadline - Date.now();
      if (remaining <= 0) {
        countdown.hidden = true;
        window.clearInterval(timer);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor(totalSeconds % 86400 / 3600);
      var minutes = Math.floor(totalSeconds % 3600 / 60);
      var seconds = totalSeconds % 60;
      time.textContent = (days ? days + 'd ' : '') +
        String(hours).padStart(2, '0') + 'h ' +
        String(minutes).padStart(2, '0') + 'm ' +
        String(seconds).padStart(2, '0') + 's';
      countdown.hidden = false;
    }

    renderCountdown();
    timer = window.setInterval(renderCountdown, 1000);
  }());

  } catch(e) { console.error(e); }
})();
})();
